import React from 'react';
import { Icon } from '../icon/Icon';
import { Tooltip } from '../tooltip/Tooltip';
import './TextInput.scss';

interface TextInputProps {
  disabled?: boolean;
  handleViewIcon?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  htmlFor: string;
  information?: boolean | string;
  inputName?: string;
  label: string;
  notificationState?: null | 'success' | 'error' | 'warning';
  notificationMessage?: null | string;
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  type?: string;
  withIcon?: boolean | string;
  value?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
  disabled,
  handleViewIcon,
  htmlFor,
  information,
  inputName,
  label,
  notificationState = '',
  notificationMessage = '',
  onInputChange,
  placeholder,
  type,
  withIcon = '',
  value
}) => {
  const randomNumber = Math.ceil(Math.random() * 1000) * Date.now();

  return (
    <div
      className={`ads-text-input ${disabled ? 'ads-text-input--disabled' : ''}`}
      data-testid="ads-text-input"
    >
      <label
        className="ads-text-input__label"
        htmlFor={`${randomNumber}-${htmlFor}`}
      >
        {label}
        {information && (
          <span
            className="ads-text-input__information-icon"
            data-testid="ads-text-input__icon"
          >
            <Tooltip
              content={`${information}`}
              ariaName="Text input information tooltip"
            />
          </span>
        )}
      </label>
      <input
        className={`ads-text-input__input ${notificationState}`}
        id={`${randomNumber}-${htmlFor}`}
        type={type}
        placeholder={placeholder}
        name={inputName}
        onChange={onInputChange}
        value={value}
        data-testid="ads-text-input__input"
        aria-disabled={disabled && true}
        disabled={disabled && true}
      />
      {withIcon && (
        <span className="ads-text-input__with-icon" onClick={handleViewIcon}>
          <Icon name={withIcon} />
        </span>
      )}
      <span className="ads-text-input__icon">
        {notificationState === 'success' && (
          <Icon name="checkmarkSolid" color="ads-color-support-success" />
        )}
        {notificationState === 'error' && <Icon name="errorSolid" />}
        {notificationState === 'warning' && <Icon name="warningSolid" />}
      </span>
      <div className={`ads-text-input__notification ${notificationState}`}>
        {notificationState === 'success' && (
          <span role="alert" data-testid="ads-text-input__notification">
            {notificationMessage}
          </span>
        )}
        {notificationState === 'error' && (
          <span role="alert" data-testid="ads-text-input__notification">
            {notificationMessage}
          </span>
        )}
        {notificationState === 'warning' && (
          <span role="alert" data-testid="ads-text-input__notification">
            {notificationMessage}
          </span>
        )}
      </div>
    </div>
  );
};
